export default "__VITE_ASSET__CtcIVPDf__"